import { types } from "mobx-state-tree";

export const relocationWidgetStore = types
  .model("State", {
    accessToken: types.optional(types.string, "", [null, undefined]),
    customerNumber: types.optional(types.string, "", [null, undefined]),
    mfaEnabled: types.optional(types.boolean, false),
    deviceCookieNeeded: types.optional(types.boolean, false),
  })
  .actions((state) => ({
    updateAccessToken(accessToken: string) {
      state.accessToken = accessToken;
    },
    updateCustomerNumber(customerNumber: string) {
      state.customerNumber = customerNumber;
    },
    updateMfaEnabled(mfaEnabled: boolean) {
      state.mfaEnabled = mfaEnabled;
    },
    updateDeviceCookieNeeded(deviceCookieNeeded: boolean) {
      state.deviceCookieNeeded = deviceCookieNeeded;
    },
  }))
  .create({
    accessToken: undefined,
  });
